var _rect, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVirtualChip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 37,
    viewBox: "0 0 43 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.777344,
    width: 42.2222,
    height: 37,
    rx: 3.3,
    fill: "url(#paint0_linear_7187:65474)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.779297 26.75H13.0009C14.2941 26.75 15.3341 25.7313 15.3341 24.4853V11.9706C15.3341 10.7245 14.2941 9.70588 13.0009 9.70588H0.779297V8.70588H13.0009C14.8417 8.70588 16.334 10.1675 16.334 11.9706V24.4853C16.334 26.2883 14.8417 27.75 13.0009 27.75H0.779297V26.75ZM12.0009 27.75V36.75H11.001V27.75H12.0009ZM30.9999 27.75V36.75H30V27.75H30.9999ZM12.0009 0L12.0007 8.705L13.0009 8.70588C14.8417 8.70588 16.334 10.1675 16.334 11.9706L16.3335 12H26.8889L26.889 11.9706C26.889 10.2407 28.2627 8.82504 30 8.71302L30 0H30.9999L30.9997 8.705L42.9993 8.70588V9.70588H30.2222C28.929 9.70588 27.889 10.7245 27.889 11.9706L27.8889 17H42.9993V18H27.8889L27.889 24.4853C27.889 25.6794 28.8441 26.6647 30.0619 26.7448L30.2222 26.75H42.9993V27.75H30.2222C28.3813 27.75 26.889 26.2883 26.889 24.4853L26.8889 23H16.3335L16.334 24.4853C16.334 26.2883 14.8417 27.75 13.0009 27.75H0.779297V26.75H13.0009C14.2941 26.75 15.3341 25.7313 15.3341 24.4853L15.3335 18H0.779297V17H15.3335L15.3341 11.9706C15.3341 10.7245 14.2941 9.70588 13.0009 9.70588H0.779297V8.70588L11.0008 8.705L11.001 0H12.0009ZM26.8889 13H16.3335V22H26.8889V13Z",
    fill: "url(#paint1_linear_7187:65474)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7187:65474",
    x1: -15.6116,
    y1: 19.6527,
    x2: 17.4056,
    y2: 56.233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBCA6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA8106"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7187:65474",
    x1: 21.8893,
    y1: 0,
    x2: 21.8893,
    y2: 36.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVirtualChip);
export default __webpack_public_path__ + "static/media/virtual-chip.6260d6df.svg";
export { ForwardRef as ReactComponent };